// =============================================
// useSuccessToast — shared success message hook
// Kipikid - מערכת נוכחות ילדים בגנים
// =============================================

import { useState, useCallback } from 'react';

export function useSuccessToast(duration = 3000) {
  const [message, setMessage] = useState('');

  const show = useCallback((msg: string) => {
    setMessage(msg);
    setTimeout(() => setMessage(''), duration);
  }, [duration]);

  return { message, show };
}
